import {Panel, FlexboxGrid, Col} from "rsuite";

export function AboutMe () {
    return(
        <Col lgPush={6} lg={12}>
            <FlexboxGrid justify={"center"}>
                <Panel className={"aboutMe"} bordered={true} shaded={true}>
                    <h1 className={"horizontalCenterHeader"}>About Me</h1>
                    <p>
                        &emsp; With a background in elementary education, backed by professional experience in Software QA, I have developed strong skills in writing comprehensive test suites, communication, and collaboration. I started my journey to QA by gaining valuable experience in software development, then progressed to writing automated tests ranging from integration tests to API testing. Throughout, I used my strengths from an education background and my experiences as a software developer to hone my focus on the user and the overall software developer experience.
                    </p>
                </Panel>
            </FlexboxGrid>
        </Col>

    );
}